import { StatementType } from "./index.js";
import { isAlterTableAddOnly, isConstraintValue, isForeignValue, isNewStatement, isPeriodToken, isSemicolonToken, isStringToken, isTableValue } from "../helper.js";
import { parserForeignKeyParser } from "./create.table.js";
//#region ../schema-sql-parser/dist/parser/statement/alter.table.add.foreignKey.js
function alterTableAddForeignKeyParser(tokens, $pos) {
	const newStatement = isNewStatement(tokens);
	const isSemicolon = isSemicolonToken(tokens);
	const isString = isStringToken(tokens);
	const isConstraint = isConstraintValue(tokens);
	const isPeriod = isPeriodToken(tokens);
	const isTable = isTableValue(tokens);
	const isForeign = isForeignValue(tokens);
	const isOnly = isAlterTableAddOnly(tokens)($pos.value);
	const isToken = () => $pos.value < tokens.length;
	const ast = {
		type: StatementType.alterTableAddForeignKey,
		name: "",
		columnNames: [],
		refTableName: "",
		refColumnNames: [],
		onDelete: "",
		onUpdate: ""
	};
	$pos.value++;
	while (isToken() && !newStatement($pos.value)) {
		let token = tokens[$pos.value];
		if (isSemicolon($pos.value)) {
			$pos.value++;
			break;
		}
		if (isTable($pos.value)) {
			token = tokens[++$pos.value];
			if (isOnly) token = tokens[++$pos.value];
			if (isString($pos.value)) {
				ast.name = token.value;
				$pos.value++;
				while (isPeriod($pos.value)) {
					if (!isString($pos.value + 1)) {
						$pos.value++;
						break;
					}
					ast.name = tokens[$pos.value + 1].value;
					$pos.value += 2;
				}
			}
			continue;
		}
		if (isConstraint($pos.value)) {
			token = tokens[++$pos.value];
			if (isString($pos.value)) $pos.value++;
			continue;
		}
		if (isForeign($pos.value)) {
			const foreignKey = parserForeignKeyParser(tokens, $pos);
			if (foreignKey) {
				ast.columnNames = foreignKey.columnNames;
				ast.refTableName = foreignKey.refTableName;
				ast.refColumnNames = foreignKey.refColumnNames;
				ast.onDelete = foreignKey.onDelete;
				ast.onUpdate = foreignKey.onUpdate;
			}
			continue;
		}
		$pos.value++;
	}
	return ast;
}
//#endregion
export { alterTableAddForeignKeyParser };
